import {addFormControlSelect2, fnToastrFormError, getSelectedCompany, resetForm} from "../jquery-functions-library";
import {element_exists} from "../functions";

export var fnDashboardProcedureTable = function () {

    var tableName = '#datatable-procedures';
    var modal = $('#modal-add-procedure');

    if (!element_exists(tableName)) return false;

    $('#procedure_responsible').select2({width: '100%'}).addClass('form-control');
    addFormControlSelect2();

    $('#datatable-procedures tbody').off('click', 'tr');
    $('#datatable-procedures tbody').on('click', 'tr', function () {
        var tableData = table.row(this).data();

        $.ajax({
            type: 'POST',
            url: '/getEmployees',
            data: {
                keepers: false
            },
            success: function (response) {
                $('#procedure_responsible').html('');
                $.each(response, function (index, value) {
                    $('#procedure_responsible').append('<option value="' + response[index]['id'] + '">' + response[index]['name'] + '</option>');
                });
                $('#procedure_task').val(tableData.procedure_task);
                $("#procedure_responsible option").each(function () {
                    for (let i = 0; i < tableData.users.length; i++) {
                        if ($(this).val() == tableData.users[i].id) {
                            $(this).prop("selected", true);
                        }
                    }
                });
                $('#procedure_responsible').trigger('change');


                $('#procedure_id').val(tableData.procedure_id);
                console.log(tableData.procedure_deadline);
                $('#procedure_deadline').val(tableData.procedure_deadline);
            },
            error: fnToastrFormError,
        });

        $('#delete-procedure').removeClass('hidden');
        $('#update-procedure').removeClass('hidden');
        $('#submit-procedure').addClass('hidden');
        modal.modal('show');
    });

    $('#add_procedure').off('click').on('click', function () {
        $('#delete-procedure').addClass('hidden');
        $('#update-procedure').addClass('hidden');
        $('#submit-procedure').removeClass('hidden');

        $.ajax({
            type: 'POST',
            url: '/getEmployees',
            data: {
                keepers: false
            },
            success: function (response) {
                $('#procedure_responsible').html('');
                $.each(response, function (index, value) {
                    $('#procedure_responsible').append('<option value="' + response[index]['id'] + '">' + response[index]['name'] + '</option>');
                });
            },
            error: fnToastrFormError,
        })
    });

    $('#add-procedure-form').off('submit').on('submit', function (e) {
        e.preventDefault();
        var selectedCompanyId = getSelectedCompany();
        var procedure_task = $('#procedure_task').val();
        var procedure_responsible = $('#procedure_responsible').val();
        var procedure_deadline = $('#procedure_deadline').val();

        $.ajax({
            type: 'POST',
            url: '/addProcedure',
            data: {
                company_id: selectedCompanyId,
                procedure_task: procedure_task,
                procedure_responsible: procedure_responsible,
                procedure_deadline: procedure_deadline
            },
            success: function (response) {
                modal.modal('hide');
            },
            error: fnToastrFormError,
        })
    });

    modal.off('hidden.bs.modal').on('hidden.bs.modal', function () {
        resetForm($('#add-procedure-form'));
        $('#procedure_responsible').html('').trigger('change');
        $(tableName).DataTable().ajax.reload(null, false);
    });

    var columns = [
        {data: 'procedure_deadline_text'},
        {data: 'procedure_deadline'},
        {data: 'procedure_task'},
        {data: 'procedure_responsible'}
    ];

    /*Rules for filling the columns*/
    var columnDefs = [
        {className: "p-l-10", width: "33%", targets: 0, orderData: 1},
        {visible: false, targets: 1},
        {className: "p-l-10", width: "33%", targets: 2},
        {className: "p-l-10", width: "33%", targets: 3}
    ];

    /*Important otherwise table misaligned*/
    $(tableName).css('width', '100%');
    var table = $(tableName).DataTable({
        // language: {
        //     url: '/language/datatables'
        // },
        language: allLangFiles.datatables,
        ajax: {
            url: '/getProcedures',
        },
        columns: columns,
        columnDefs: columnDefs,
        bFilter: false,
        dom: 'frtipB',
        buttons: [
            'copy', 'csv', 'excel', 'pdf', 'print'
        ],
        destroy: true,
        bInfo: false,
        pageLength: -1,
        bLengthChange: false,
        scrollX: true,
        lengthMenu: [10, 25, 50, 75, 100],
        initComplete: function (settings, json) {
            table.draw();
        },
    });

    $('#delete-procedure').off('click').on('click', function (e) {
        e.preventDefault();

        var procedure_id = $('#procedure_id').val();

        $.ajax({
            type: 'POST',
            url: '/deleteProcedure',
            data: {
                procedure_id: procedure_id,
            },
            success: function (response) {
                modal.modal('hide');
            },
            error: fnToastrFormError,
        })
    });

    $('#update-procedure').off('click').on('click', function (e) {
        e.preventDefault();

        var procedure_id = $('#procedure_id').val();
        var selectedCompanyId = getSelectedCompany();
        var procedure_task = $('#procedure_task').val();
        var procedure_responsible = $('#procedure_responsible').val();
        var procedure_deadline = $('#procedure_deadline').val();

        $.ajax({
            type: 'POST',
            url: '/updateProcedure',
            data: {
                procedure_id: procedure_id,
                company_id: selectedCompanyId,
                procedure_task: procedure_task,
                procedure_responsible: procedure_responsible,
                procedure_deadline: procedure_deadline
            },
            success: function (response) {
                modal.modal('hide');
            },
            error: fnToastrFormError,
        });
    });
};